import theme from '../../theme';
export var defaultPhrases = {
    datepickerStartDatePlaceholder: 'Anreise wählen',
    datepickerStartDateLabel: 'Anreise',
    datepickerEndDateLabel: 'Abreise',
    datepickerEndDatePlaceholder: 'Abreise wählen',
    resetDates: 'ZURÜCKSETZEN',
    close: '',
};
export var today = new Date();
export var weekdayLabels = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
export var defaultTabTheme = {
    breakpoints: ['64em'],
    reactDatepicker: {
        daySize: [50, 50],
        fontFamily: theme.typography.font.family.lato,
        colors: {
            primaryColor: '#75CA2B',
        },
        navButtonBorder: 'none',
        navButtonIconHeight: '30px',
        navButtonIconWidth: '30px',
        navButtonIconColor: '#212121',
        monthLabelFontWeight: '900',
        monthLabelFontSize: '1rem',
        monthLabelLineHeight: '1.5rem',
        monthLabelColor: '#212121',
        dayLabelFontWeight: '400',
        dayLabelFontSize: '0.8125rem',
        dayLabelColor: '#00000080',
        dayColor: '#212121',
        dayFontWeight: '400',
        dayFontSize: '1rem',
        daySelectedColor: '#212121',
        daySelectedHoverColor: '#212121',
        daySelectedFirstOrLastColor: 'white',
        dayHoverBackground: 'white',
        dayHoverRangeBackground: '#2298DA14',
        daySelectedBackground: '#2298DA14',
        daySelectedHoverBackground: '#2298DA14',
        daySelectedFirstOrLastBackground: 'white',
        dayBorderColor: 'none',
        daySelectedBorderColor: 'none',
        daySelectedFirstOrLastBorderColor: 'none',
        datepickerBackground: 'white',
        datepickerBoxShadow: "0 0.75rem 1.0625rem 0.125rem #21212123,\n            0 0.3125rem 1.375rem 0.25rem #2121210F,\n            0 0.4375rem 1rem 0 #21212119",
        datepickerBorderRadius: '0.375rem',
        datepickerPosition: 'absolute',
        datepickerWidth: 'auto',
        datepickerPadding: '0 1.5rem',
        datepickerResetDatesWrapperMargin: '1.25rem',
        datepickerMonthsGridOverflow: 'scroll',
        monthLabelMargin: '1.25rem',
        datepickerPreviousMonthButtonPosition: 'absolute',
        datepickerPreviousMonthButtonTop: '1rem',
        datepickerPreviousMonthButtonLeft: '1rem',
        datepickerNextMonthButtonPosition: 'absolute',
        datepickerNextMonthButtonRight: '1rem',
        datepickerNextMonthButtonTop: '1rem',
        monthDayLabelMargin: '0.625rem',
    },
};
export var defaultMobileTheme = {
    breakpoints: ['22em'],
    reactDatepicker: {
        daySize: [45, 50],
        fontFamily: theme.typography.font.family.lato,
        colors: {
            primaryColor: '#75CA2B',
        },
        navButtonBorder: 'none',
        navButtonIconColor: '#212121',
        monthLabelFontWeight: '300',
        monthLabelFontSize: '1rem',
        monthLabelLineHeight: '1.25rem',
        monthLabelColor: '#212121',
        dayLabelFontWeight: '300',
        dayLabelFontSize: '1rem',
        dayLabelColor: '#212121',
        dayColor: '#212121',
        dayFontWeight: '400',
        dayFontSize: '1rem',
        daySelectedColor: '#212121',
        daySelectedHoverColor: '#212121',
        daySelectedFirstOrLastColor: 'white',
        dayHoverBackground: 'white',
        dayHoverRangeBackground: '#2298DA14',
        daySelectedBackground: '#2298DA14',
        daySelectedHoverBackground: '#2298DA14',
        daySelectedFirstOrLastBackground: 'white',
        dayBorderColor: '#F7F7F7',
        daySelectedBorderColor: 'none',
        daySelectedFirstOrLastBorderColor: 'none',
        datepickerBackground: 'white',
        datepickerBoxShadow: "0 0.75rem 1.0625rem 0.125rem #21212123,\n            0 0.3125rem 1.375rem 0.25rem #2121210F,\n            0 0.4375rem 1rem 0 #21212119",
        datepickerBorderRadius: '0.375rem',
        datepickerPosition: 'absolute',
        datepickerPadding: '0',
        datepickerResetDatesWrapperMargin: '2.5rem 1.25rem',
        datepickerMonthsGridHeight: '100%',
        datepickerMonthsGridOverflow: 'scroll',
        monthLabelMargin: '1.25rem',
        datepickerPreviousMonthButtonPosition: 'absolute',
        datepickerPreviousMonthButtonTop: '-2rem',
        datepickerPreviousMonthButtonLeft: '1rem',
        datepickerNextMonthButtonPosition: 'absolute',
        datepickerNextMonthButtonRight: '1rem',
        datepickerNextMonthButtonTop: '-2rem',
        monthDayLabelMargin: '0.625rem',
        closeMargin: '3.125rem 1.25rem 0 0',
    },
};
